import React, { useState } from "react";
import "./auth.css";
import logo from "../../Asserts/Images/b2blogoo.png";
import { Input, Button, message } from "antd";
import otp_img from "../../Asserts/Images/otpVerificationImg.png";
import { useLocation, useNavigate } from "react-router-dom";
import Instance from "../../AxiosConfig";

const OtpVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || ""; 
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [timer, setTimer] = useState(0);

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.replace(/[^0-9]/g, "");
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      const next = document.getElementById(`otp-${index + 1}`);
      next?.focus();
    }
  };

  // ✅ Verify OTP API
  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join("");

    if (!email) {
      message.warning("Email is missing. Please go back and try again.");
      return;
    }

    if (enteredOtp.length !== 6) {
      message.warning("Please enter the 6-digit OTP.");
      return;
    }

    try {
      setLoading(true);
      const response = await Instance.post("/auth/verify-otp", {
        email: email,
        otp: enteredOtp,
      });
      console.log("Verify OTP Response:", response);
      if (response.data) {
        message.success("OTP verified successfully!");
        navigate("/create-password", { state: { email } });
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      if (error.response?.data?.message) {
        message.error(error.response.data.message);
      } else {
        message.error("Invalid OTP or something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  // ✅ Resend OTP API
  const handleResendOtp = async () => {
    if (!email) {
      message.warning("Email is missing. Please go back and try again.");
      return;
    }

    try {
      setResendLoading(true);
      const response = await Instance.post("/admin/forgot/send-otp", { email });
      if (response.data) {
        message.success("OTP resent successfully!");
        setTimer(30); // Start 30-second countdown
        const countdown = setInterval(() => {
          setTimer((prev) => {
            if (prev <= 1) {
              clearInterval(countdown);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      message.error(error.response?.data?.message || "Failed to resend OTP.");
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="otp-container">
      <div className="container-fluid">
        <div className="row">
          {/* Left side image */}
          <div className="col-md-6">
            <div className="otp-img">
              <img src={otp_img} alt="OTP Illustration" />
            </div>
          </div>

          {/* Right side form */}
          <div className="col-md-6">
            <div className="otp-form">
              <div className="d-flex justify-content-center">
                <img src={logo} alt="Logo" className="otp-logo" />
              </div>

              <div className="otp-content">
                <p className="otp-title">OTP Verification</p>
                <p className="otp-subtext">
                  Enter OTP code sent to <span>{email || "your email"}</span>
                </p>
              </div>

              <div className="otp-inputs">
                {otp.map((data, index) => (
                  <Input
                    key={index}
                    id={`otp-${index}`}
                    value={data}
                    maxLength={1}
                    onChange={(e) => handleChange(e.target.value, index)}
                    style={{
                      width: "50px",
                      height: "50px",
                      textAlign: "center",
                      fontSize: "20px",
                      borderRadius: "8px",
                      marginRight: "8px",
                    }}
                  />
                ))}
              </div>

              <Button
                type="primary"
                block
                className="otp-button mt-3"
                onClick={handleVerifyOtp}
                loading={loading}
              >
                Verify & Proceed
              </Button>

              <div className="otp-footer-section">
                <p className="otp-footer">
                  Didn’t get OTP?{" "}
                  {timer > 0 ? (
                    <span>Resend in {timer}s</span>
                  ) : (
                    <span>resend in 30 seconds</span>
                  )}
                </p>
                <button
                  className="resend-btn"
                  onClick={handleResendOtp}
                  disabled={timer > 0 || resendLoading}
                  style={{
                    opacity: timer > 0 ? 0.6 : 1,
                    cursor: timer > 0 ? "not-allowed" : "pointer",
                  }}
                >
                  {resendLoading ? "Resending..." : "Resend Code"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
